export const socialLinks = {
    tiktok: 'https://www.tiktok.com/@thevibecollective.co?_t=8oSMvESHjRq',
    facebook: 'https://m.facebook.com/p/The-Vibe-Collective-61563203970422/?mibextid=LQQJ4d&wtsid=rdr_0x41agj88XQIoNsGT',
    instagram: 'https://www.instagram.com/the.vibeco?igsh=MWd1aDhzNGo3ZTRsZQ%3D%3D&utm_source=qr'
}